import React from 'react';
import styles from 'styles/modules/Post.module.scss';

const PostBody = ({ children }) => {
    return <div className={styles.postBody}>{children}</div>;
};

export default PostBody;
